import {ChangeDetectorRef, Component, ViewChild} from '@angular/core';
import {
  Alert,
  AlertController,
  Content,
  IonicPage,
  ItemSliding,
  Loading,
  LoadingController,
  Navbar,
  NavController,
  NavParams,
  Platform,
  Popover,
  PopoverController,
  Range,
  Select
} from 'ionic-angular';
import {TranslateService} from "@ngx-translate/core";
import {ReaderService} from "../../providers/reader.service";
import {VizixService} from "../../providers/vizix.service";
import {AppConfigPage} from "../app-config/app-config";
import {TagReadResponse} from "../../models/reader-model/tagReadResponse";
import {NAV_PARAM_RETURN_PAGE, READER_MODE_GEIGER, RETURN_PAGE_UNASSOCIATED_TAGS} from "../../app/app.constants";
import {SimulatorService} from "../../providers/simulator.service";
import {TagItem} from "../../models/tagItem";
import {ReportExecutionResponse} from "vizixc/dist/interfaces/reportExecution.interface";
import {isUndefined} from "util";
import {DeviceSelectPage} from "../device-select/device-select";
import {Subscription} from "rxjs/Subscription";
import {ZoneType} from "../../models/zoneDeptRelation";
import {InsomniaService} from "../../providers/insomnia.service";
import {UnassociatedService} from '../../providers/unassociated.service';
import {PopoverUnassociatedProgressPage} from '../popover-unassociated-progress/popover-unassociated-progress';
import {ReportDefinitionResponse} from 'vizixc/dist/interfaces/report.definition.interface';


@IonicPage()
@Component({
  selector: 'page-unassociated-tags',
  templateUrl: 'unassociated-tags.html',
})
export class UnassociatedTagsPage {

  private tag = '[UNASSOCIATED TAGS]';
  private downloadInterval: number;
  private pageNumber: number = 1;
  public isUnassociatedTagsScreenShowing: boolean = false;
  public isGeigerMode: boolean = false;

  public loadProgress: number = 0;
  public totalOnHands: number = 0;
  public selectedTag: string = "";
  public readerPower: number = 100;

  //DepartmentZones values
  private departmentZones: Array<ZoneType> = [];
  private selectedZone: any;
  /*public departmentList: DepartmentsZones[];
  public selectedDepartment: DepartmentsZones;
  public selectedZone: ZoneType;*/


  public loading: Loading;
  public loadingProgress: Loading;
  public alertServerError: Alert;
  public alertReaderError: Alert;
  public alertConfigurationError: Alert;
  public alertReportError: Alert;
  public alertPrompt: Alert;
  public alertReaderDisconnectedError: Alert;
  public alertNoUnassociatedTags: Alert;
  public alertReaderNotConnectedError: Alert;


  public isDialogShowing: boolean = false;
  public isAlertShowing: boolean = false;

  public isTriggerPulled: boolean = false;
  public isRealTriggerPulled: boolean = false;

  public isPopPageActive: boolean = false; // Used to prevent multiple 'pop' calls

  public temporaryArray: Array<any> = [];
  public inventoryArray: Array<TagItem> = [];
  public inventoryShownArray: Array<TagItem> = [];
  public inventoryFoundArray: Array<TagItem> = [];
  private inventorySearchArray: Array<string> = []; // This array includes only the EPCs returned by the Expected report
  private isAllResponseOk: boolean = true;
  private readerDisconnectSubscription: Subscription;

  private triggerPressTimer: any;

  public prefix: string = "";
  public currentPage = 1;
  public pageSize = 20;

  public showDim: boolean = false;
  public geigerPercentage: number = 0;

  public isDragging: boolean = false;

  popoverProgress: Popover;

  @ViewChild(Navbar) navBar: Navbar;
  @ViewChild(Content) content: Content;
  @ViewChild('Select1') selectZone: Select;
  @ViewChild('rangePower') rangeBarReaderPower: Range;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public translate: TranslateService,
              private readerService: ReaderService,
              private cdr: ChangeDetectorRef,
              public platform: Platform,
              private simulatorService: SimulatorService,
              private vizixService: VizixService,
              private _insomniaService: InsomniaService,
              private loadingCtrl: LoadingController,
              private alertCtrl: AlertController,
              private popoverCtrl: PopoverController,
              private unassociatedService: UnassociatedService) {
    // Init all alerts
    this.initAlerts();


    this.downloadInterval = this.vizixService.configurationApp.AppParametersConfiguration.DownloadInterval.value;
  }


  initAlerts() {
    this.initAlertReaderDisconnectedError();
    this.initAlertReaderNotConnectedError();
    this.initAlertReaderError();
    this.initAlertServerError();
    this.initAlertNoUnassociatedTags();
    this.initAlertConfigurationError();
    this.initAlertReportError();
  }

  initAlertServerError() {
    this.alertServerError = this.alertCtrl.create({
      title: this.translate.instant('cycle_count.alerts.server_error.title'),
      message: this.translate.instant('cycle_count.alerts.server_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('cycle_count.alerts.server_error.ok'),
          handler: () => {
            this.initAlertServerError();  // We call this recursively because the alert is destroyed on dismiss
            this.dismissLoading();
            this.isAlertShowing = false;
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertConfigurationError() {
    this.alertConfigurationError = this.alertCtrl.create({
      title: this.translate.instant('unassociated_tags.alerts.configuration_error.title'),
      message: this.translate.instant('unassociated_tags.alerts.configuration_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('unassociated_tags.alerts.configuration_error.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertConfigurationError(); // We call this recursively because the alert is destroyed on dismiss
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertReportError() {
    this.alertReportError = this.alertCtrl.create({
      title: this.translate.instant('unassociated_tags.alerts.report_error.title'),
      message: this.translate.instant('unassociated_tags.alerts.report_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('unassociated_tags.alerts.report_error.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertReportError(); // We call this recursively because the alert is destroyed on dismiss
          }
        }
      ]
    });
  }

  initAlertPrompt() {
    this.alertPrompt = this.alertCtrl.create({
      title: 'Login',
      message: "Enter some filter",
      inputs: [
        {
          name: 'report filter',
          placeholder: 'report filter'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertReaderError() {
    this.alertReaderError = this.alertCtrl.create({
      title: this.translate.instant('unassociated_tags.alerts.reader_error.title'),
      message: this.translate.instant('unassociated_tags.alerts.reader_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('unassociated_tags.alerts.reader_error.ok'),
          handler: () => {
            console.log(this.tag, 'READER NOT CONNECTED');
            this.initAlertReaderError(); // We call this recursively because the alert is destroyed on dismiss
            this.isAlertShowing = false;
            //this.navCtrl.push(DeviceSelectPage);
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error WITH THE READER CONNECTION --> WHEN IT DISCONNECTS
  initAlertReaderDisconnectedError() {
    this.alertReaderDisconnectedError = this.alertCtrl.create({
      title: this.translate.instant('unassociated_tags.alerts.reader_error_disconnected.title'),
      message: this.translate.instant('unassociated_tags.alerts.reader_error_disconnected.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('unassociated_tags.alerts.reader_error_disconnected.ok'),
          handler: () => {
            console.log(this.tag, 'READER DISSCONNECTED');
            this.initAlertReaderDisconnectedError(); // We call this recursively because the alert is destroyed on dismiss
            this.isAlertShowing = false;
            this.closeAllPopupsAndPop();
            //this.navCtrl.push(DeviceSelectPage);
          }
        }
      ]
    });
  }

  // Alert that shows when the reader is not connected and user tries to do something in the module
  initAlertReaderNotConnectedError() {
    this.alertReaderNotConnectedError = this.alertCtrl.create({
      title: this.translate.instant('menu_tracker_retail.alerts.error_pair.title'),
      message: this.translate.instant('menu_tracker_retail.alerts.error_pair.message'),
      buttons: [
        {
          text: this.translate.instant('menu_tracker_retail.alerts.error_pair.cancel'),
          role: 'cancel',
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertReaderNotConnectedError();
          }
        },
        {
          text: this.translate.instant('menu_tracker_retail.alerts.error_pair.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertReaderNotConnectedError();
            this.navCtrl.push(DeviceSelectPage, {'backToMenu': true, 'returnPage': RETURN_PAGE_UNASSOCIATED_TAGS});
            // this.navCtrl.popToRoot().then(() => { // To prevent the page stack to increase every time
            // });
          }
        }
      ]
    });
  }

  initAlertNoUnassociatedTags() {
    this.alertNoUnassociatedTags = this.alertCtrl.create({
      title: this.translate.instant('unassociated_tags.alerts.noUnassociatedTags.title'),
      message: this.translate.instant('unassociated_tags.alerts.noUnassociatedTags.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('unassociated_tags.alerts.noUnassociatedTags.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.initAlertNoUnassociatedTags();
            this.cancelInventoryMode();
          }
        }
      ]
    });
  }

  ionViewDidLoad() {

    //get zoneTypes the first time
    this.getZoneType();
    this.cdr.detectChanges();

    // set power default reader
    this.readerPower = this.vizixService.configurationApp.UnassociatedConfiguration.DefaultPowerLevel.value;
    this.setReaderPower();

    this.initReaderStatusListenerIfConnected();


    //insomnia service with the method insomniaKeepAwakeScreen() will Prevent the screen of the mobile device from falling asleep. (Only in this screen)
    this._insomniaService.insomniaKeepAwakeScreen().subscribe(
      (response: any) => {
        console.log('[INSOMNIA PLUGIN]', response);
      }, (error) => {
        console.error('[INSOMNIA PLUGIN]', 'Error Keeping application awake');
      }
    );
  }

  getZoneType() {
    this.departmentZones = [];
    // this.departmentZones=this.vizixService.getVizixZones(this.selectedDepartment,this.vizixDepartmentArray);
    this.departmentZones = this.vizixService.getFirstDifferentsZones(false);
    this.selectedZone = this.departmentZones[0];
    this.cdr.detectChanges();
  }


  initReaderStatusListenerIfConnected() {
    this.isReaderConnected().then((isConnected) => {
      if (isConnected) {
        this.initReaderStatusListener();
      } else {
        // this.alertReaderNotConnectedError.present();
        // this.isAlertShowing = true;
      }
    });
  }

  ionViewWillEnter() {
    this.platform.registerBackButtonAction(() => {
      this.goBack();
    });
  }

  ionViewDidEnter() {
    this.initReaderStatusListenerIfConnected();
    if (this.isGeigerMode) {
      this.cancelGeigerMode();
    } else if (this.isUnassociatedTagsScreenShowing) {
      this.initReaderInventory();
    }
    this.cdr.reattach();
    this.cdr.detectChanges();

    //insomnia service with the method insomniaKeepAwakeScreen() will Prevent the screen of the mobile device from falling asleep. (Only in this screen)
    this._insomniaService.insomniaKeepAwakeScreen().subscribe(
      (response: any) => {
        console.log('[INSOMNIA PLUGIN]', response);
      }, (error) => {
        console.error('[INSOMNIA PLUGIN]', 'Error Keeping application awake');
      }
    );
  }

  unsubscribeAll() {
    if (this.readerDisconnectSubscription) {
      this.readerDisconnectSubscription.unsubscribe();
    }
  }

  // Called every time we do a reader operation
  isReaderConnected(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.readerService.isConnected().subscribe(
        (result) => {
          if (result) {
            resolve(true); // Connected
          } else {
            this.rangeBarReaderPower.disabled = true;
            console.error("Reader not connected"); // Not connected
            resolve(false);
          }
        },
        (error) => {
          console.error("Reader not connected", error); // Not connected
          resolve(false);
        }
      );
    });
  }

  // Go to App Config Page
  goToAppConfig() {
    if (!this.isTriggerPulled) {
      this.stopReader();
      let returnNavParams = {};
      returnNavParams[NAV_PARAM_RETURN_PAGE] = RETURN_PAGE_UNASSOCIATED_TAGS;
      this.navCtrl.push(AppConfigPage, returnNavParams);
    }
  }

  setReaderPower() {
    this.simulateTriggerReleased(false);
    this.readerService.dynamicPowerEnable(true);
    this.readerService.setReaderPower(this.readerPower, READER_MODE_GEIGER).subscribe(
      (response: any) => {
        console.log(this.tag, 'Set Reader Power Response', response);
        if (this.isGeigerMode && this.isUnassociatedTagsScreenShowing == false) {
          this.setTriggerListener();
        }
      }, (error) => {
        console.log(this.tag, 'ERROR', error);
      }
    );
  }

  ionViewWillLeave() {
    this.stopReader();
    this.unsubscribeAll();
    this.cdr.detach();
    //insomnia service with the method insomniaAllowScreenSleepAgain will screen sleep again when go to other page
    this._insomniaService.insomniaAllowScreenSleepAgain().subscribe(
      (response: any) => {
        console.log('[INSOMNIA PLUGIN]', response);
      }, (error) => {
        console.error('[INSOMNIA PLUGIN]', 'Error allowing appliccation sleep again');
      }
    );
  }

  //on press continue button once user has been chosen zone and department
  executeUnassociatedTagsReportAndShowList() {
    this.isReaderConnected().then((isConnected) => {
      if (isConnected) {
        let reportBody = {};
        reportBody = {
          [this.vizixService.configurationApp.UnassociatedConfiguration.FilterLabelStoreID.value]: String(this.vizixService.getStoreId()),
          [this.vizixService.configurationApp.UnassociatedConfiguration.FilterLabelZoneType.value]: String(this.selectedZone.idZone),
        };

        this.initShowProgressPopover();
        this.getReportPrefix().then((success) => {
          if (success) {
            this.initAlertPrompt();
            // TODO dynamic form implementation here
            this.vizixService.VizixPostReportExecutionUnassociatedTags(reportBody, this.pageNumber, this.downloadInterval).subscribe(
              (data: ReportExecutionResponse | ReportDefinitionResponse | any) => {
                switch (data.constructor.name) {
                  case 'ReportDefinitionResponse':
                    this.popoverProgress.dismiss();
                    this.alertPrompt.present();
                    break;
                  case 'ReportExecutionResponse':
                    this.isAllResponseOk = true;
                    let numberOfRequests = 1;
                    if (data.total <= this.downloadInterval) {
                      this.unassociatedService.setProgress(data.total > 0 ? 100 : 0);
                      setTimeout(() => {
                        this.popoverProgress.dismiss();
                        this.prepareList(data.results);
                      }, 100);
                    }
                    else {
                      let progress;
                      numberOfRequests = data.total / this.downloadInterval;
                      numberOfRequests = Math.ceil(numberOfRequests) - 1;
                      progress = 100 / numberOfRequests + 1;
                      this.unassociatedService.setProgress(progress);

                      this.temporaryArray = data.results;
                      const getResult = (incrementNumberRequest) => {
                        this.pageNumber++;
                        if (incrementNumberRequest == numberOfRequests) {
                          if (this.isAllResponseOk) {
                            this.prepareList(this.temporaryArray);
                            this.unassociatedService.setProgress(100);
                          }
                          else {
                            //Show error alert
                            this.popoverProgress.dismiss();
                            this.alertServerError.present();
                            this.isAlertShowing = true;
                            this.pageNumber = 1;
                            this.unassociatedService.setProgress(0);
                          }

                          this.popoverProgress.dismiss();
                        }
                        else {
                          this.vizixService.VizixPostReportExecutionUnassociatedTags(reportBody, this.pageNumber, this.downloadInterval)
                            .finally(() => {
                              getResult(incrementNumberRequest + 1);
                            }).subscribe(
                            (data: ReportExecutionResponse) => {
                              this.temporaryArray = this.temporaryArray.concat(data.results);
                              progress = ((incrementNumberRequest + 2) * 100) / numberOfRequests;
                              this.unassociatedService.setProgress(progress);
                            },

                            (error) => {
                              this.isAllResponseOk = false;
                              console.log(this.tag, "Response incomplete");
                            }
                          );
                        }
                      };
                      getResult(0);
                    }
                    break;
                }
              },
              err => {
                console.log(this.tag, err);
                this.popoverProgress.dismiss();
                this.alertServerError.present();
                this.isAlertShowing = true;
                this.showUnassociatedTagsList(false);
              },
              () => {
                // this.dismissLoading();
              });
          } else {
            this.popoverProgress.dismiss();
            this.alertReportError.present();
            this.isAlertShowing = true;
          }
        }, () => {
          this.popoverProgress.dismiss();
          this.alertServerError.present();
          this.isAlertShowing = true;
        });
      } else {
        this.alertReaderNotConnectedError.present();
        this.isAlertShowing = true;
      }
    });
  }

  prepareList(resultArray) {


    for (let result of resultArray) {
      this.inventorySearchArray.push(result['serial']);
      this.inventoryArray.push(new TagItem(result['serial'], null, false, false));
      this.totalOnHands += 1;
    }

    if (this.totalOnHands > 0) {
      if (this.totalOnHands < this.pageSize) {
        for (let i = 0; i < this.totalOnHands; i++) {
          this.inventoryShownArray.push(new TagItem(this.inventoryArray[i].epc, null, false, false));
        }
        this.cdr.detectChanges();
      }
      else {
        for (let i = 0; i < this.pageSize; i++) {
          this.inventoryShownArray.push(new TagItem(this.inventoryArray[i].epc, null, false, false));
        }
        this.cdr.detectChanges();
      }

      this.showUnassociatedTagsList(true);
      this.initReaderInventory();
    }
    else {
      this.alertNoUnassociatedTags.present();
      this.isAlertShowing = true;
      this.showUnassociatedTagsList(false);
    }

  }

  showUnassociatedTagsList(showList: boolean) {
    this.isUnassociatedTagsScreenShowing = showList;
    if (showList) {

    } else {

    }
  }

  initReaderInventory() {
    this.setTriggerListener();
    console.log(this.tag, 'Initializing Inventory Mode');
    this.readerService.initInventory(this.inventorySearchArray).subscribe(
      (tagResponse: TagReadResponse) => {
        // Tag read
        console.log(this.tag, 'TAG: ', tagResponse);
        this.processTagInventory(tagResponse);
      }, (error) => {
        console.log(this.tag, 'ERROR', error);
      }
    );
  }

  stopReader() {
    this.isReaderConnected().then(() => {
      this.readerService.stopScanCC().subscribe(
        (response: any) => {
          // Tag read
          console.log(this.tag, 'Stop scan response', response);
        }, (error) => {
          console.log(this.tag, 'ERROR', error);
        }
      );
    }, () => {
      this.dismissAll();
      this.alertReaderError.present();
      this.isAlertShowing = true;
    }).catch(error => console.log(this.tag, error));
  }

  // Returns timestamp for 00:00:00 today
  getTodayDateMillis(): number {
    let date = new Date();
    date.setHours(0, 0, 0);
    return date.getTime();
  }

  setTriggerListener() {
    if (this.readerService.setTriggerListener()) {
      this.readerService.setTriggerListener().subscribe(
        (triggerResponse: boolean) => {
          console.log(this.tag, 'Trigger State: ', triggerResponse);
          this.isTriggerPulled = triggerResponse;
          this.isRealTriggerPulled = triggerResponse;
          if (!this.isTriggerPulled && this.isGeigerMode) {
            clearTimeout(this.triggerPressTimer);
            this.cancelGeigerMode();
          }
          this.cdr.detectChanges();
        }, (error) => {
          console.log(this.tag, 'Trigger State error: ', error);
        }
      );
    } else {
      console.log(this.tag, 'Trigger Observer not set!');
    }
  }

  /**
   * Simulates the trigger pulled
   * if (simulatorEnabled) -> isRealTriggerPulled = isTriggerPulled
   */
  simulateTriggerPulled() {
    this.isTriggerPulled = true;

    if (this.simulatorService.isSimulatorEnabled) {
      this.isRealTriggerPulled = true;
    }

    this.cdr.detectChanges();

    this.readerService.simulateTriggerPress().subscribe(
      (response) => {
        console.log(this.tag, 'Trigger Pulled', response);
        this.setTriggerListener();
      },
      (error) => {
        console.log(this.tag, 'Trigger Pull error', error);
      }
    );

    this.setTriggerListener();
  }

  /**
   * Simulates the trigger released
   * @param {boolean} temporal defines whether the view should stay (true) or return to inventory mode (false)
   */
  simulateTriggerReleased(temporal: boolean) {
    this.isTriggerPulled = false;

    if (this.simulatorService.isSimulatorEnabled) {
      this.isRealTriggerPulled = false;
    }

    this.geigerPercentage = 0;

    if (!temporal && this.isGeigerMode) {
      this.cancelGeigerMode();
    }
    this.cdr.detectChanges();

    // this.dismissLoading();

    this.readerService.simulateTriggerRelease().subscribe(
      (response) => {
        console.log(this.tag, 'Trigger Released', response);
        this.setTriggerListener();
      },
      (error) => {
        console.log(this.tag, 'Trigger Release error', error);
      }
    );

    this.setTriggerListener();
  }

  toggleTrigger() {
    if (this.isTriggerPulled) {
      this.simulateTriggerReleased(false);
    } else {
      this.simulateTriggerPulled();
    }
  }

  private initReaderStatusListener() {
    console.log(this.tag, 'Initializing Reader Status Listener');
    this.readerDisconnectSubscription = this.readerService.setStatusListener().subscribe((response) => {
      if (response.hasOwnProperty('connected') && !response.connected) {
        console.log(this.tag, 'Reader disconnected!');
        this.dismissAll();
        this.alertReaderDisconnectedError.present();
        this.isAlertShowing = true;
      }
    }, (error) => {
      this.dismissAll();
      this.alertReaderError.present();
      this.isAlertShowing = true;
    });
  }

  // Process Tag in Inventory mode
  processTagInventory(tag: TagReadResponse) {
    if (!this.isGeigerMode) {
      if (tag.value.startsWith(this.prefix)) {
        // first we check if it is not in the found list (to ignore)
        for (let tagShown of this.inventoryShownArray) {
          if (tag.value == tagShown.epc && tagShown.isFound) {
            return;
          }
        }

        if (tag.upc) { // SGTIN
          // First we check if the tag is in the array of values to search
          if (this.inventorySearchArray.indexOf(tag.upc) > -1) {
            this.switchToGeigerForTag(tag);
          } else { // If not found by UPC, we check by EPC TODO: ANALYZE IF NECESSARY
            if (this.inventorySearchArray.indexOf(tag.value) > -1) {
              this.switchToGeigerForTag(tag);
            } // else, tag not found, skip
          }
        } else { // GTIN
          if (this.inventorySearchArray.indexOf(tag.value) > -1) {
            this.switchToGeigerForTag(tag);
          } // else, tag not found, skip
        }
      }
    }
  }

  switchToGeigerForTagTemplate(tag: TagItem,event:any) {
    setTimeout(() => {
      if (event.changedTouches[0].target.innerText.trim() == "Found" && event.changedTouches[0].target.clientWidth == 0) {
        console.log(this.tag, tag.epc, 'Not Found');
        tag.isFound = false;
      }
    }, 700)

    if (!this.isDragging) {
      this.switchToGeigerForTag(new TagReadResponse().fromTagItem(tag), true)
    } else {
      this.isDragging = false;
    }
  }

  switchToGeigerForTag(tag: TagReadResponse, fromTemplate?: boolean) {
    console.log(this.tag, 'TAG FOUND!: ', tag);
    if (!fromTemplate) {
      this.addToListShown(tag);
    }

    this.initReaderGeigerMode(tag.value, tag.upc, !fromTemplate);
    this.triggerPressTimer = setTimeout(() => this.simulateTriggerPulled(), 200);
  }

  addToListShown(tag: TagReadResponse) {
    let inList: boolean = false;
    let inListTag: TagItem = null;

    // Check if tag is not already in the shown list
    for (let shownTag of this.inventoryShownArray) {
      if (shownTag.epc == tag.value) {
        inList = true;
        inListTag = shownTag;
        break;
      }
    }

    if (!inList) {
      // If the RSSI is greater than the Acceptance Criteria, add it directly to the top
      if (tag.rssiPercentage >= this.vizixService.configurationApp.UnassociatedConfiguration.ProximityAcceptanceCriteria.value) {
        console.log(this.tag, 'Unshift', tag);
        this.inventoryShownArray.unshift(new TagItem(tag.value, tag.upc ? tag.upc : null, true, false));
      } else { // If not, add it to the bottom
        console.log(this.tag, 'Push', tag);
        this.inventoryShownArray.push(new TagItem(tag.value, tag.upc ? tag.upc : null, false, false)); // TODO: Must be: null, false, false
      }
    } else { // If already on the list, set swipeable to true and move it to the top
      if (tag.rssiPercentage >= this.vizixService.configurationApp.UnassociatedConfiguration.ProximityAcceptanceCriteria.value) {
        inListTag.isSwipeable = true;
        this.addToListShownTop(inListTag);
      }
    }
    this.cdr.detectChanges();
  }

  // Swap to top
  addToListShownTop(inListTag: TagItem) {
    let index = this.inventoryShownArray.indexOf(inListTag);
    for (let i = index; i > 0; i--) { // Swap to top using array destructuring
      [this.inventoryShownArray[i], this.inventoryShownArray[i - 1]] = [this.inventoryShownArray[i - 1], this.inventoryShownArray[i]];
    }
  }

  // Init geiger mode
  initReaderGeigerMode(tag: string, upc: string, simulateTriggerPress: boolean) {
    console.log(this.tag, 'Switching to geiger mode', tag);

    this.isGeigerMode = true;

    this.isReaderConnected().then(() => {

      if (simulateTriggerPress) {
        this.triggerPressTimer = setTimeout(() => {
          if (!this.isTriggerPulled && this.isRealTriggerPulled) {
            this.simulateTriggerPulled();
          }
        }, 800);
      }

      this.setTriggerListener();
      this.selectedTag = tag;

      this.cdr.detectChanges();

      this.readerService.initGeiger(tag).subscribe(
        (tagResponse: TagReadResponse) => {
          console.log(this.tag, 'Geiger Response', tagResponse);
          this.processTagGeiger(tag, tagResponse);
        }, (error) => {
          console.log(this.tag, 'ERROR', error);
        }
      );
    }, () => {
      this.dismissAll();
      this.alertReaderError.present();
      this.isAlertShowing = true;
    });
  }

  dismissAll() {
    this.dismissLoading();
    this.dismissAlerts();
  }

  dismissLoading() {
    if (this.isDialogShowing) {
      if (this.loading) {
        this.loading.dismiss();
      }

    }
    this.isDialogShowing = false;
  }

  dismissAlerts() {
    if (this.alertServerError) {
      this.alertServerError.dismiss();
      this.initAlertServerError();
    }
    // if (this.alertNoInformationFoundError) {
    //   this.alertNoInformationFoundError.dismiss();
    //   this.initAlertNoInformationFoundError();
    // }
    // if (this.alertInvalidFormatError) {
    //   this.alertInvalidFormatError.dismiss();
    //   this.initAlertInvalidFormatError();
    // }
    if (this.alertReaderError) {
      this.alertReaderError.dismiss();
      this.initAlertReaderError();
    }
    if (this.alertReaderDisconnectedError) {
      this.alertReaderDisconnectedError.dismiss();
      this.initAlertReaderDisconnectedError();
    }
    this.isAlertShowing = false;
  }

  processTagGeiger(tag: string, tagResponse: TagReadResponse) {
    if (this.isTriggerPulled) { // To prevent messages to arrive after trigger is released
      this.geigerPercentage = tagResponse.rssiPercentage < 100 ? tagResponse.rssiPercentage : 100;
      if (tagResponse.rssiPercentage >= this.vizixService.configurationApp.UnassociatedConfiguration.ProximityAcceptanceCriteria.value) {
        for (let shownTag of this.inventoryShownArray) {
          if (shownTag.epc == tag) {
            shownTag.isSwipeable = true;
            this.addToListShownTop(shownTag);
            break;
          }
        }
      }
    } else {
      this.geigerPercentage = 0;
    }
    this.cdr.detectChanges();
  }

  /*
  custom dialog present
   */
  showLoading() {

    if (!this.isDialogShowing) {
      this.loading = this.loadingCtrl.create({
        content: this.translate.instant('unassociated_tags.loadings.loading')
      });

      this.isDialogShowing = true;
      console.log(this.tag, 'IS DIALOG SHOWING');
      console.log(this.tag, true);
      this.loading.present();
      this.isDialogShowing = true;

      this.loading.onDidDismiss(() => {
        this.isDialogShowing = false;
      });
    }
  }


  // Shows the zone and dept selection screen
  cancelInventoryMode() {
    this.readerService.stopScanCC().subscribe();
    this.clearAll();
  }

  // Shows the unassociated tags list screen
  cancelGeigerMode() {
    this.clearGeigerMode();
    this.initReaderInventory();
  }

  clearAll() {
    this.unassociatedService.setProgress(0);
    this.inventoryArray = [];
    this.inventoryShownArray = [];
    this.inventoryFoundArray = [];
    this.temporaryArray = [];
    this.totalOnHands = 0;
    this.pageNumber = 1;
    this.isUnassociatedTagsScreenShowing = false;
    this.cdr.detectChanges();
  }

  clearGeigerMode() {
    this.selectedTag = "";
    this.isGeigerMode = false;
    this.cdr.detectChanges();
  }

  // Go back in the navigation flow
  goBack() {
    if (!this.isAlertShowing && !this.isDialogShowing && !this.isPopPageActive) {

      if (this.isGeigerMode) { // If we are showing the geiger, then go back to the list
        this.stopReader();
        this.cancelGeigerMode();
      } else if (this.isUnassociatedTagsScreenShowing) { // If we are on the list
        this.cancelInventoryMode();
      } else { // If none of the above, we are on the Zone Dept selection
        this.closeAllPopupsAndPop();
      }
      this.readerService.dynamicPowerEnable(false);
    }
  }

  closeAllPopupsAndPop() {
    if (!this.isPopPageActive) {
      if (this.selectZone) {
        this.selectZone.close();
      }
      this.navCtrl.pop();
      this.isPopPageActive = true;
    }
  }

  onScrollDown() {
    if (this.pageSize * this.currentPage <= this.inventoryArray.length) {
      for (let i = (this.currentPage * this.pageSize); i < ((this.currentPage + 1) * this.pageSize); i++) {
        if (i < this.inventoryArray.length && this.inventoryShownArray.findIndex(item => item.epc === this.inventoryArray[i].epc) == -1) {
          this.inventoryShownArray.push(new TagItem(this.inventoryArray[i].epc, this.inventoryArray[i].upc, this.inventoryArray[i].isSwipeable, this.inventoryArray[i].isFound));
        }
        else {
          break;
        }
      }
      this.currentPage++;
    }
  }

  onDragItem(itemSliding: ItemSliding, item: TagItem) {
    let percent = itemSliding.getSlidingPercent();
    if (percent >= 1) {
      // is showing found
      console.log(this.tag, item.epc, 'Found');
      item.isFound = true;
    } else {
      // not showing found
      console.log(this.tag, item.epc, 'Not Found');
      item.isFound = false;
    }
  }

  getReportPrefix(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.vizixService.VizixGetUnassociatedTagsPrefix().subscribe(
        (prefix: string) => {
          if (!isUndefined(prefix) && prefix != null) {
            console.log(this.tag, 'Prefix from report', prefix);
            this.prefix = prefix;
            resolve(true);
          } else {
            resolve(false);
          }
        },
        err => {
          console.log(this.tag, 'An error occurred getting report prefix', err);
          reject();
        }
      );
    });
  }

  initShowProgressPopover() {
    if (!this.isAlertShowing) {
      this.popoverProgress = this.popoverCtrl.create(PopoverUnassociatedProgressPage,
        {
          title: this.translate.instant('unassociated_tags.popovers.progress.title'),
        }, {
          enableBackdropDismiss: false,
          showBackdrop: true
        });
      this.isAlertShowing = true;
      this.popoverProgress.present();
      this.popoverProgress.onWillDismiss(() => {
        this.isAlertShowing = false;
        this.showDim = false;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/unassociated-tags/unassociated-tags.ts